import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { finalize, first } from 'rxjs';
import { ShiftResponse, ShiftsClient } from '../../../shared';
import { LoadingDefaults } from '../../../shared/models/loading-defaults.model';
import { RplLoadingService } from '../../../shared/services/rpl-loading.service';

export const shiftResolver: ResolveFn<ShiftResponse | undefined> = (
  route: ActivatedRouteSnapshot,
) => {
  const client = inject(ShiftsClient);
  const loadingService = inject(RplLoadingService);

  const idRaw = route.queryParamMap.get('shiftId');
  const shiftId = Number(idRaw);
  if (shiftId <= 0) return undefined;

  let loadingId: string | undefined;
  const timeout = setTimeout(() => {
    loadingId = loadingService.start();
  }, LoadingDefaults.StartIndicatorTimeout);

  return client.getShiftById(shiftId).pipe(
    first(),
    finalize(() => {
      clearTimeout(timeout);
      loadingService.end(loadingId);
    }),
  );
};
